






























































/** @format */

import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
@Component
export default class CustomerInfo extends Vue {
  data() {
    return {
      previewVisible: false,
      previewImage: ''
    };
  }
  // 客户信息
  consList = [
    {
      title: '姓名',
      prop: 'consName',
      consName: ''
    },
    {
      title: '房号',
      prop: 'consRoom',
      consRoom: ''
    },
    {
      title: '联系电话',
      prop: 'consTel',
      consTel: ''
    },
    {
      title: '身份证号',
      prop: 'consCardId',
      consCardId: ''
    }
  ];
  // 判断输入框是否禁用
  @Prop({ type: Boolean, default: false }) private onDisabled: any;
  @Prop({ type: Boolean, default: true }) private showUpload: any;
  // 上传照片列表
  @Prop() private fileList: any;
  @Emit('onHandleCancel') private onHandleCancel() {
    // @ts-ignore
    this.previewVisible = false;
    console.log('-onHandleCancel-');
  }
  @Emit('onHandlePreview') private onHandlePreview() {
    console.log('-onHandlePreview-');
  }
  @Emit('onHandleChange') private onHandleChange() {
    console.log('-onHandleChange-');
  }
}
